import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

interface PropsType {
  url: string;
  titleQrCodeModal: string;
  descriptionQrCodeModal: string;
}

@Component({
  selector: "app-driveb-app-download-badge-modal",
  templateUrl: "./app-download-badge-modal.component.html",
  styleUrls: ["./app-download-badge-modal.component.scss"],
  standalone: false
})
export class AppDownloadBadgeModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropsType,
    private matDialogRef: MatDialogRef<AppDownloadBadgeModalComponent>
  ) {}

  url = "";

  ngOnInit(): void {
    this.url = this.data.url;
  }

  closeDialog(): void {
    this.matDialogRef.close();
  }

  copyQRData(): void {
    void navigator.clipboard.writeText(this.data.url);
  }
}
